class Navigation {
    static navigation = document.querySelector('[data-navigation]');

    static sidebar = document.querySelector('[data-navigation-sidebar]');

    static openButton = document.querySelector('[data-navigation-open]');

    static closeButton = document.querySelector('[data-navigation-close]');

    static init = () => {
        Navigation.openButton.addEventListener('click', Navigation.open);
        Navigation.closeButton.addEventListener('click', Navigation.close);
    };

    static open = () => {
        Navigation.navigation.classList.remove('hidden');
        Navigation.navigation.classList.add('block');

        setTimeout(() => {
            window.addEventListener('click', Navigation.closeOnClickOutside);
            window.addEventListener('keydown', Navigation.closeOnEsc);
        }, 1);
    };

    static close = () => {
        Navigation.navigation.classList.remove('block');
        Navigation.navigation.classList.add('hidden');

        window.removeEventListener('click', Navigation.closeOnClickOutside);
        window.removeEventListener('keydown', Navigation.closeOnEsc);
    };

    static closeOnEsc = (event) => {
        if (event.keyCode === 27) {
            Navigation.close();
        }
    };

    static closeOnClickOutside = (event) => {
        try {
            if (Navigation.sidebar.contains(event.target) === false) {
                Navigation.close();
            }
        } catch (error) {
            // it's progressive..
        }
    };
}

(() => {
    Navigation.init();
})();
